import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { BaseEntityService } from './baseentity-service';

@Injectable()
export class CosechaService extends BaseEntityService {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    responseItemToEntity(responseItem: any): any {
        return {
            ID: responseItem.Id,
            Cosecha: responseItem.Cosecha,
            Desde: responseItem.AnoDesde,
            Hasta: responseItem.AnoHasta
        };
    }

    apiRoute: string = '/api/cosecha';
}

export interface Cosecha {
  ID: number,
  Cosecha: string,
  Desde: number,
  Hasta: number,
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/cosecha-service.ts